import { jsx as e } from "react/jsx-runtime";
//#region src/IconDetailPageDownload.tsx
function t(t) {
	return /* @__PURE__ */ e("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		...t,
		children: /* @__PURE__ */ e("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m12.141 19.804 8.43-8.054H15V2.78c0-.43-.336-.78-.75-.78h-4.5c-.414 0-.75.35-.75.78v8.97H3.429l8.429 8.054H3.75c-.414 0-.75.424-.75.848s.336.848.75.848h16.5c.414 0 .75-.424.75-.848s-.336-.848-.75-.848z",
			clipRule: "evenodd"
		})
	});
}
t.displayName = "IconDetailPageDownload";
//#endregion
export { t as default };

//# sourceMappingURL=IconDetailPageDownload.js.map